import { Component, OnInit, Inject, ElementRef, ViewChild, HostBinding } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { List } from '../set-property-update.component';

@Component({
	selector: 'common-list-params',
	templateUrl: './list-params.component.html',
	styleUrls: ['./list-params.component.scss']
})
export class ListParamsComponent implements OnInit {
	@HostBinding('class.list-params') hostClass = true;
	@ViewChild('åè¡¨è®¾ç½®', { static: true })
	åè¡¨è®¾ç½®: ElementRef;
	type = 'list';
	listTxt = '';
	constructor(public dialogRef: MatDialogRef<ListParamsComponent>, @Inject(MAT_DIALOG_DATA) public lists?: List[]) {
		if (!lists) {
			return;
		}
		this.lists.forEach((list, index) => {
			if (this.lists.length === index + 1) {
				this.listTxt += list.Value + '=' + list.Label;
			} else {
				this.listTxt += list.Value + '=' + list.Label + ',';
			}
		});
	}

	ngOnInit() {
		this.åè¡¨è®¾ç½®.nativeElement.parentElement.parentElement.style = 'padding:16px 16px 16px 24px;';
	}
}
